import { Component, Inject, OnInit, Optional, ViewChild } from "@angular/core";
import { ModalRef, MODAL_DATA_VAR } from "mis-design-system/mis-modal";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../constants/assets.constants";
import { NsWISConfigurations } from "../../../models/configurations.model";
import { FormGroup } from "@angular/forms";
import { NsEmpWebExpData } from "../../../models/emp-web-exp.model";

@Component({
  selector: "mis-employee-web-exp-adhoc-shifts",
  templateUrl: "./adhoc-shifts.component.html",
  styleUrls: ["./adhoc-shifts.component.scss"]
})
export class AdhocShiftsComponent implements OnInit {
  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  configs: NsWISConfigurations.IConfigurations;
  nextDayLogoutShift: NsEmpWebExpData.IShiftData[] = [];
  data: string;
  shifts: object;
  selectedLoginShift: object;
  selectedLogoutShift: object;
  label: [] = [];
  formData: FormGroup;
  adhocEnabled = false;
  @ViewChild("selectedShift") selectedShift;

  constructor(@Optional() private modalref: ModalRef, @Inject(MODAL_DATA_VAR) data) {
    this.formData = data.formData;
    this.data = data.data;
    this.shifts = data.shifts;
    this.nextDayLogoutShift = data.nextDayLogoutShift;
    this.adhocEnabled = data.adhocEnabled;
  }

  ngOnInit(): void {
    this.selectedLoginShift = new Object(this.formData.get("startShift").value);
    this.selectedLogoutShift = new Object(this.formData.get("endShift").value);
    this.label = this.data === "Check-In" ? this.shifts[0] : this.shifts[1];
  }
  ngAfterViewInit(): void {
    this.selectedShift?.nativeElement?.querySelector(".selected")?.scrollIntoView({ behavior: "smooth", block: "start" });
  }
  shiftSelect(data: object) {
    this.modalref.close(data);
  }
  closeModal() {
    this.modalref.close();
  }
}
